import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {RecordsDataRequestQueryParams} from "../../../../types/records-table.types";
import {ProductCardDefect, ProductCardDefectValue, UpdateFeedbackDefectsParams} from "../types/defects-modal.types";
import {baseUrl} from "../../../../constants/base-url";
import {Observable} from "rxjs";
import {
  feedbacksResourceType,
  productCardsDefectsResourceType,
  productCardsDefectValuesResourceType
} from "../configs/defects-modal-config";
import {jsonPathHeaders} from "../../../../models/http-headers";


@Injectable({
  providedIn: 'root'
})
export class DefectsModalApiService {
  private http: HttpClient = inject(HttpClient);

  public getProductCardsDefects(queryParams: RecordsDataRequestQueryParams): Observable<Array<ProductCardDefect>> {
    return this.http.get<Array<ProductCardDefect>>(`${baseUrl}/${productCardsDefectsResourceType.path}/`, {
      params: queryParams
    });
  }

  public getProductCardsDefectValues(queryParams: RecordsDataRequestQueryParams): Observable<Array<ProductCardDefectValue>> {
    return this.http.get<Array<ProductCardDefectValue>>(`${baseUrl}/${productCardsDefectValuesResourceType.path}/`, {
      params: queryParams
    });
  }

  public updateFeedbackDefects({ id, feedbackDefects }: UpdateFeedbackDefectsParams): Observable<void> {
    return this.http.put<void>(`${baseUrl}/${feedbacksResourceType.path}/${id}/defects`, feedbackDefects, {
      headers: jsonPathHeaders
    });
  }
}
